import React from "react";
import useTranslator from "../../hooks/useTranslator";
import { Button, Modal } from "../design";
import "./InsuranceReviewModal.css";

const InsuranceReviewModal = ({ show, onHide, onGotIt }) => {
  const { _t } = useTranslator();

  return (
    <Modal
      open={show}
      onClose={onHide}
      id="insurance-review-modal"
      icon={
        <img
          src="/images/clock-icon.svg"
          alt="clock"
          className="review-clock-icon"
        />
      }
      title={_t("purchaseInsuranceReviewRequestPopupTitle")}
      description={_t("purchaseInsuranceReviewRequestPopupDescription")}
      actions={
        <Button size="lg" block onClick={onGotIt}>
          {_t("gotIt")}
        </Button>
      }
    />
  );
};

export default InsuranceReviewModal;
